export default {
    getMessages: state => state.messages
};
